import React from 'react';
import Link from '@atlaskit/link';
import * as Styled from '../styled';
import { FormattedMessage } from 'react-intl-next';

const TermsAndPrivacyPolicy = () => (
	<Styled.TermsAndPrivacyWrapper>
		<FormattedMessage
			defaultMessage='By clicking "Try it free", you will be enrolled in Confluence and agree to the Atlassian <termsOfServiceLinkText>Cloud Terms of Service</termsOfServiceLinkText> and <privacyPolicyLinkText>Privacy Policy</privacyPolicyLinkText>.'
			id="projectpages.templatepreview.termsandprivacy"
			values={{
				termsOfServiceLinkText: (chunks: React.ReactNode[]) => (
					<Link target="_blank" href="https://www.atlassian.com/legal/cloud-terms-of-service">
						{chunks}
					</Link>
				),
				privacyPolicyLinkText: (chunks: React.ReactNode[]) => (
					<Link target="_blank" href="https://www.atlassian.com/legal/privacy-policy">
						{chunks}
					</Link>
				),
			}}
		/>
	</Styled.TermsAndPrivacyWrapper>
);
export default TermsAndPrivacyPolicy;
